import { Card, Typography } from 'antd'
import { QuestionNode } from 'features/libra/ontology/ontologyFieldTypes'
import { FlowchartAnswer } from 'features/libra/sections/flowchartSection/flowchartTypes'
import { FC } from 'react'
import styled from 'styled-components'

import { BooleanInput } from './BooleanInput'

const { Title, Text } = Typography

interface QuestionNodeRendererProps {
  node: QuestionNode
  onAnswer: (answer: FlowchartAnswer) => void
}

export const QuestionNodeRenderer: FC<QuestionNodeRendererProps> = ({
  node,
  onAnswer,
}) => {
  return (
    <StyledCard>
      <QuestionTitle level={4}>{node.name}</QuestionTitle>
      {node.description && (
        <DescriptionText type='secondary'>{node.description}</DescriptionText>
      )}
      <InputContainer>
        {node.type === 'boolean' && <BooleanInput onAnswer={onAnswer} />}
        {/* TODO: Add other input types here */}
        {node.type !== 'boolean' && (
          <Text type='warning'>
            Input type &quot;{node.type}&quot; not yet implemented
          </Text>
        )}
      </InputContainer>
    </StyledCard>
  )
}

const StyledCard = styled(Card)`
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
`

const QuestionTitle = styled(Title)`
  margin-bottom: 0.5rem !important;
`

const DescriptionText = styled(Text)`
  display: block;
  margin-bottom: 1rem;
  font-size: 14px;
`

const InputContainer = styled.div`
  margin-top: 1rem;
`
